import React from "react";

interface Props {
  folderPath: string;
  onNavigate: (path: string) => void;
  /** Locked-folder mode: breadcrumb never shows segments above this path. */
  rootPath?: string;
}

export function Breadcrumb({ folderPath, onNavigate, rootPath = "" }: Props) {
  const rootLabel = rootPath ? rootPath.split("/").pop() || rootPath : "All assets";
  if (!folderPath || folderPath === rootPath) {
    return <nav className="breadcrumb"><span className="crumb root current">{rootLabel}</span></nav>;
  }
  // Segments below the (possibly locked) root only.
  const rel =
    rootPath && folderPath.startsWith(`${rootPath}/`) ? folderPath.slice(rootPath.length + 1) : folderPath;
  const segments = rel.split("/").filter(Boolean);
  const crumbs: Array<{ label: string; path: string }> = [{ label: rootLabel, path: rootPath }];
  let acc = rootPath;
  for (const seg of segments) {
    acc = acc ? `${acc}/${seg}` : seg;
    crumbs.push({ label: seg, path: acc });
  }
  return (
    <nav className="breadcrumb" aria-label="Folder path">
      {crumbs.map((c, i) => (
        <React.Fragment key={c.path}>
          {i > 0 && <span className="sep">›</span>}
          {i === crumbs.length - 1 ? (
            <span className="crumb current">{c.label}</span>
          ) : (
            <button className="crumb" onClick={() => onNavigate(c.path)}>
              {c.label}
            </button>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
